import { fromJS } from 'immutable';

import {
  GET_PIN_FOR_AUTHORIZE,
  GET_PIN_FOR_AUTHORIZE_LOADED,
  GET_CODE_OF_AUTHORIZE,
  GET_CODE_OF_AUTHORIZE_LOADED,
  GET_CODE_OF_AUTHORIZE_ERROR,
  SET_FORM_PHONE_NUMBER_REQUEST,
  SET_FORM_PIN_NUMBER_REQUEST,
  VALID_INPUT_PHONE,
  VALID_INPUT_PIN,
  EDIT_PHONE_NUMBER,
  SHOW_MESSAGE_WITHOUT_SUBSCRIPTION,
  SET_URL_FORM_TO_SUBSCRIPTION,
  VALID_CHECKBOX,
  VALID_EMAIL
} from './constants';

const initialState = fromJS({
  loading: null,
  phoneNumber: null,
  pinNumber: null,
  pinForAuthorizeData: null,
  pinForAuthorizeLoaded: null,
  pinForAuthorizeError: null,
  formRequestConfig: null,
  pinForAuthorize: null,
  subscriptionUri: null,
  urlFormToSubscription: null,
  contactMeByTelOnly: false,
  email: ''
});

const manualAccessReducer = (state = initialState, action) => {
  switch (action.type) {
    case VALID_INPUT_PHONE:
      return state
        .set('formRequestConfig', { ...state.get('formRequestConfig'), btntext: 'Continuar' })
        .set('phoneNumber', action.phoneNumber)
        .set('pinForAuthorizeLoaded', null)
        .set('urlFormToSubscription', null)
        .set('pinForAuthorizeError', null);
    case VALID_INPUT_PIN:
      return state
        .set('pinNumber', action.pinNumber);
    case EDIT_PHONE_NUMBER:
      return state
        .set('phoneNumber', action.phoneNumber)
        .set('pinNumber', null)
        .set('pinForAuthorizeLoaded', false);
    case SET_FORM_PHONE_NUMBER_REQUEST:
      return state
        .set('formRequestConfig', action.props)
        .set('loading', action.props.isLoading)
        .set('urlFormToSubscription', null);
    case SET_FORM_PIN_NUMBER_REQUEST:
      return state
        .set('formRequestConfig', action.props)
        .set('loading', 1);
    case SET_URL_FORM_TO_SUBSCRIPTION:
      return state
        .set('formRequestConfig', { ...state.get('formRequestConfig'), btntext: 'Voltar' })
        .set('urlFormToSubscription', action.url);
    case GET_PIN_FOR_AUTHORIZE:
      return state
        .set('loading', 0)
        .set('pinNumber', null)
        .set('pinForAuthorizeLoaded', null)
        .set('pinForAuthorizeError', null);
    case GET_PIN_FOR_AUTHORIZE_LOADED:
      return state
        .set('pinForAuthorizeData', action.data)
        .set('pinForAuthorizeLoaded', true)
        .set('pinForAuthorizeError', null)
        .set('loading', 1);
    case GET_CODE_OF_AUTHORIZE:
      return state
        .set('pinForAuthorizeError', null)
        .set('loading', 0);
    case GET_CODE_OF_AUTHORIZE_LOADED:
      return state
        .set('loading', 1);
    case GET_CODE_OF_AUTHORIZE_ERROR:
      return state
        .set('pinForAuthorizeError', action.error)
        .set('loading', 1);
    case SHOW_MESSAGE_WITHOUT_SUBSCRIPTION:
      return state
        .set('subscriptionUri', action.subscriptionUri);
    case VALID_CHECKBOX:
      return state
        .set('contactMeByTelOnly', action.contactMeByTelOnly);
    case VALID_EMAIL:
      return state
        .set('email', action.email);
    default:
      return state;
  }
};

export default manualAccessReducer;



// WEBPACK FOOTER //
// ./src/containers/ManualAccessPage/reducer.js